/* eslint-disable no-undef */
import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { from, concatMap, filter, tap, of } from 'rxjs'
import { handleMessages, refreshToken } from '../modules/client/utilities'

export default {
  namespaced: true,
  state: () => ({
    token: null,
    encryptToken: null,
    tokenExp: null,
    user: null,
    csrfToken: null,

    imageSrc: null,
    imageCode: null,
    imageToken: null,

    captchaToken: null,
    captchaEKey: null,

    hasSimpleSignUp: false,

    // login form
    username: null,
    password: null,

    // register form
    regUsername: null,
    regTel: null, // string || intelinput object
    regPassword: null,
    regRecommendedCode: null,
    regConfirmPassword: null,
    regZalo: null,
    regBirthday: null,
    regEmail: null,
    regEmailVerifyCode: null,
    regWithdrawalPassword: null,
    regActualName: null,
    regCountryCode: null,
    regCurrency: null,
    regGender: null, // 性別：M, F

    loginModal: {
      show: false,
      target: '/',
      category: 'login'
    },

    recoveryModal: {
      show: false,
      category: 'email'
    },

    showSelectSignUpTypeModal: false,

    // forgotPassword form
    fpCategory: 'sms',
    fpUsername: null,
    fpTel: null, // string || intelinput object
    fpCountryCode: null,
    fpEmail: null,

    // modify login password
    originPassword: null,
    newPassword: null,
    confirmPassword: null,

    // modify pay password
    isPayPasswordSetting: false, // 是否有設定過支付密碼
    originPayPassword: null, // 兩種用途：登錄密碼 / 原支付密碼
    newPayPassword: null,
    confirmPayPassword: null,

    // forgot pay password
    loginPassword: null,
    emailVerifyCode: null
  }),
  actions: {
    getImageSrc(context) {
      const { commit } = context
      return from(
        this.$axios.$post(
          `/webapi/index/getValidateImage/v2`,
          {},
          getAxiosConfig(context)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('IMAGE_SRC', data.image)
            commit('IMAGE_TOKEN', data['6cfsezdad3'])
          })
        )
        .toPromise()
    },
    refreshCSRFToken(context) {
      const { commit } = context
      return from(this.$axios.$post('/api/refreshCSRFToken', {}))
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ result }) => {
            commit('CSRF_TOKEN', result)
          })
        )
        .toPromise()
    },
    login(context) {
      const { state, rootState, commit } = context
      return from(
        this.$axios.$post(
          `/api/login`,
          {
            username: state.username,
            password: state.password,
            imageCode: state.imageCode,
            deviceId: rootState.deviceId
          },
          {
            headers: {
              'x-csrf-token': state.csrfToken,
              '6cfsezdad3': state.imageToken
            },
            timeout: 10 * 1000
          }
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ result }) => {
            commit('TOKEN', result.token)
            commit('TOKEN_EXP', result.user.exp)
            commit('USER', result.user)
          })
        )
        .toPromise()
    },
    refreshToken({ state }) {
      const isFinPath = $nuxt.$route.path.startsWith('/user/financial-service')
      const isAccPath = $nuxt.$route.path.startsWith('/user/account-setting')
      return this.$axios.$post(
        `/api/refreshToken/${isFinPath || isAccPath ? 'CASHIER' : 'DEFAULT'}`,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + state.token
          },
          timeout: 10 * 1000
        }
      )
    },
    logout({ state }) {
      if (!state.token) {
        return Promise.resolve()
      }
      return this.$axios.$post(
        `/api/logout`,
        {},
        {
          headers: {
            'x-csrf-token': state.csrfToken,
            Authorization: 'Bearer ' + state.token
          }
        }
      )
    },
    gameLogout({ state }) {
      if (!state.token) {
        return Promise.resolve()
      }
      return this.$axios.$post(
        `/webapi/game/logoutPlayer`,
        {},
        getAxiosConfig(arguments[0])
      )
    },
    signUp({ state, rootState }, payload) {
      const data = {
        loginname: state.regUsername,
        password: state.regPassword,
        imageCode: state.imageCode,
        userCurrency: state.regCurrency,
        birthday: state.regBirthday,
        email: state.regEmail,
        emailVerifyCode: state.regEmailVerifyCode
      }

      if (typeof state.regTel === 'string') {
        data.phone = state.regTel?.replace(/[\s-()]/g, '')
      } else {
        data.phoneInfo = state.regTel
      }

      if (process.env.COMP_ID === 'kb') {
        const freeDemoDomains = process.env.FREE_DEMO_DOMAINS.split(
          /,\s?/
        ).filter(Boolean)

        data.isFreeDemo = freeDemoDomains.includes(rootState.domain)
      }

      if (state.regRecommendedCode) {
        data.agentcode = state.regRecommendedCode
      } else if ($nuxt.$route.query.aid) {
        data.agentcode = $nuxt.$route.query.aid
      }

      if (state.regActualName) {
        data.accountName = state.regActualName
      }

      if (state.regGender) {
        data.gender = state.regGender
      }

      data.howToKnow = window.location.href

      data.deviceId = rootState.deviceId

      if ($nuxt.$route.query.btag) {
        data.btag = $nuxt.$route.query.btag
      } else if (Cookies.get('btag')) {
        data.btag = Cookies.get('btag')
      }

      if ($nuxt.$route.query.scAffiliateId) {
        data.scAffiliateId = $nuxt.$route.query.scAffiliateId
      } else if (Cookies.get('scAffiliateId')) {
        data.scAffiliateId = Cookies.get('scAffiliateId')
      }

      return this.$axios.$post(`/api/signUp${payload || ''}`, data, {
        headers: {
          'x-csrf-token': state.csrfToken,
          '6cfsezdad3': state.imageToken
        },
        timeout: 10 * 1000
      })
    },
    forgotPassword({ state }) {
      const data = {
        loginname: state.fpUsername,
        imageCode: state.imageCode,
        email: state.fpEmail ? state.fpEmail : ''
      }

      if (typeof state.fpTel === 'string') {
        data.phone = state.fpTel?.replace(/[\s-()]/g, '')
      } else {
        data.phoneInfo = state.fpTel?.formatted ? state.fpTel : null
      }

      return this.$axios.$post(
        `/webapi/index/getPasswordByEmailOrPhone`,
        data,
        getAxiosConfig(arguments[0], {
          headers: {
            '6cfsezdad3': state.imageToken
          }
        })
      )
    },
    modifyPassword(context) {
      const { state } = context
      const data = {
        oldPassword: state.originPassword,
        newPassword: state.newPassword,
        confirmPassword: state.confirmPassword
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/changePassword`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    sendEmailVerify(context) {
      const { state, rootState } = context

      const data = {
        email: state.regEmail,
        domain: rootState.domain
      }
      if (state.captchaToken && state.captchaEKey) {
        data.captchaToken = state.captchaToken
        data.captchaEKey = state.captchaEKey
      }

      return this.$axios.$post(
        `/webapi/index/sendEmailVerify`,
        data,
        getAxiosConfig(context)
      )
    },
    modifyPayPassword(context) {
      const { state, rootState } = context
      if (state.isPayPasswordSetting) {
        const data = {
          oldWithdrawPwd: state.originPayPassword,
          newWithdrawPwd: state.newPayPassword,
          confirmWithdrawPwd: state.confirmPayPassword
        }
        return from(refreshToken(context))
          .pipe(
            concatMap(() =>
              from(
                this.$axios.$post(
                  `/webapi/user/changeWithdrawPwd`,
                  data,
                  getAxiosConfig(context)
                )
              )
            )
          )
          .toPromise()
      } else {
        const data = {
          withdrawPwd: state.newPayPassword,
          confirmWithdrawPwd: state.confirmPayPassword
        }
        if (rootState.authModule.user.oauth === 'NONE') {
          data.password = state.originPayPassword
        }
        return from(refreshToken(context))
          .pipe(
            concatMap(() =>
              from(
                this.$axios.$post(
                  `/webapi/user/submitWithdrawPwd`,
                  data,
                  getAxiosConfig(context)
                )
              )
            )
          )
          .toPromise()
      }
    },
    getUser(
      context,
      { token, path = $nuxt.$route.path } = {
        token: null,
        path: $nuxt.$route.path
      }
    ) {
      const { state, commit } = context
      const isFinPath = path.startsWith('/user/financial-service')
      const isAccPath = path.startsWith('/user/account-setting')
      return from(
        this.$axios.$post(
          `/api/getUserInfo/${isFinPath || isAccPath ? 'CASHIER' : 'DEFAULT'}`,
          {},
          getAxiosConfig(arguments[0], {
            headers: {
              Authorization: 'Bearer ' + (token || state.token)
            }
          })
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({ store: context })
            })
          ),
          tap(({ result }) => {
            commit('TOKEN_EXP', result.exp)
            commit('USER', result.user)
          })
        )
        .toPromise()
    },
    getClientIp({ state }) {
      return this.$axios.$post(
        `/api/getClientIp`,
        {},
        {
          headers: {
            'x-csrf-token': state.csrfToken
          },
          timeout: 1500
        }
      )
    },
    isOneTimeEmail({ state }) {
      return this.$axios.$get(
        `/webapi/index/isTempEmail/${state.regEmail}`,
        getAxiosConfig(arguments[0])
      )
    },
    checkEmailVerifyCode({ state }, payload = {}) {
      return this.$axios.$get(
        `/webapi/index/emailVerify`,
        getAxiosConfig(arguments[0], {
          params: {
            email: payload.email || state.regEmail,
            emailVerifyCode: payload.emailVerifyCode
          }
        })
      )
    },
    checkEmailVerifyCodeV2(context) {
      const { state } = context
      return this.$axios.$post(
        `/webapi/index/v2/emailVerify?email=${state.regEmail}&emailVerifyCode=${
          state.regEmailVerifyCode
        }`,
        getAxiosConfig(arguments[0])
      )
    },
    checkUsername(context) {
      const { state } = context
      return this.$axios.$post(
        `/webapi/index/loginnameVerify`,
        {
          loginname: state.regUsername
        },
        {
          headers: {
            '6cfsezdad3': state.imageToken
          }
        }
      )
    },
    getSimpleSignUpEnabled(context) {
      const { commit } = context
      return from(
        this.$axios.$get(
          `/webapi/index/enableQuickRegister`,
          getAxiosConfig(arguments[0])
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({ store: context })
            })
          ),
          tap(({ data }) => {
            commit('HAS_SIMPLE_SIGN_UP', data.QuickRegister)
          })
        )
        .toPromise()
    },
    getSignUpToken(context) {
      const { commit } = context
      return from(
        this.$axios.$post(
          `/webapi/index/getSignToken`,
          getAxiosConfig(arguments[0])
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({ store: context })
            })
          ),
          tap(({ headers }) => {
            commit('IMAGE_TOKEN', headers['6cfsezdad3'])
          })
        )
        .toPromise()
    },
    callbackOauthGoogle(context, { code }) {
      const { rootState } = context
      //  body: {
      //    'code': 'xxxxxxxxxxxx',
      //    'deviceId': '0587',
      //    'howToKnow': '0987',
      //    'btag': '5987',
      //    'scAffiliateId': '8787'
      //  }
      const data = {
        code,
        deviceId: rootState.deviceId,
        howToKnow: window.location.href
      }

      if ($nuxt.$route.query.btag) {
        data.btag = $nuxt.$route.query.btag
      } else if (Cookies.get('btag')) {
        data.btag = Cookies.get('btag')
      }

      if ($nuxt.$route.query.scAffiliateId) {
        data.scAffiliateId = $nuxt.$route.query.scAffiliateId
      } else if (Cookies.get('scAffiliateId')) {
        data.scAffiliateId = Cookies.get('scAffiliateId')
      }

      return from(
        this.$axios.$post(`/webapi/oauth/GG/callback.go`, data, {
          timeout: 10 * 1000
        })
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({ store: context })
            })
          ),
          concatMap(({ data }) => of(data))
        )
        .toPromise()
    },
    callbackOauthTelegram(context, { authInfo }) {
      const { rootState } = context
      //  body: {
      //    'authInfo': {...}, // by callback auth data of telegram
      //    'deviceId': '0587',
      //    'howToKnow': '0987',
      //    'btag': '5987',
      //    'scAffiliateId': '8787'
      //  }
      const data = {
        authInfo,
        deviceId: rootState.deviceId,
        howToKnow: window.location.href
      }

      if ($nuxt.$route.query.btag) {
        data.btag = $nuxt.$route.query.btag
      } else if (Cookies.get('btag')) {
        data.btag = Cookies.get('btag')
      }

      if ($nuxt.$route.query.scAffiliateId) {
        data.scAffiliateId = $nuxt.$route.query.scAffiliateId
      } else if (Cookies.get('scAffiliateId')) {
        data.scAffiliateId = Cookies.get('scAffiliateId')
      }

      return from(
        this.$axios.$post(`/webapi/oauth/TG/callback.go`, data, {
          timeout: 10 * 1000
        })
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({ store: context })
            })
          ),
          concatMap(({ data }) => of(data))
        )
        .toPromise()
    },
    oauth(context, payload) {
      return from(
        this.$axios.$post(`/api/oauth`, payload, getAxiosConfig(arguments[0]))
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({ store: context })
            })
          ),
          concatMap(() => of(payload))
        )
        .toPromise()
    },
    forgotPayPassword(context, payload) {
      const { state, rootState } = context
      const data = {
        step: payload
      }
      switch (payload) {
        case 'VERIFY_PWD':
          data.password = state.loginPassword
          break
        case 'GET_EMAIL_VERIFY_CODE':
          data.email = state.user.email
          data.domain = rootState.domain
          break
        case 'VERIFY_EMAIL':
          data.emailVerifyCode = state.emailVerifyCode
          break
        case 'RESET_WITHDRAW_PWD':
          data.withdrawPwd = state.newPayPassword
          data.confirmWithdrawPwd = state.confirmPayPassword
          break
        default:
      }

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/user/forgotWithdrawPwd`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getZendeskJWTForToken(context) {
      const { state } = context
      return from(
        this.$axios.$get(`/webapi/zendesk/user/jwt`, {
          headers: {
            Authorization: 'Bearer ' + state.token
          }
        })
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({ store: context })
            })
          ),
          concatMap(({ data }) => of(data))
        )
        .toPromise()
    }
  },
  mutations: {
    TOKEN(state, payload) {
      state.token = payload
    },
    ENCRYPT_TOKEN(state, payload) {
      state.encryptToken = payload
    },
    TOKEN_EXP(state, payload) {
      state.tokenExp = payload
    },
    USER(state, payload) {
      state.user = payload
    },
    CSRF_TOKEN(state, payload) {
      state.csrfToken = payload
    },

    IMAGE_SRC(state, payload) {
      state.imageSrc = payload
    },
    IMAGE_CODE(state, payload) {
      state.imageCode = payload
    },
    IMAGE_TOKEN(state, payload) {
      state.imageToken = payload
    },
    CAPTCHA_TOKEN(state, payload) {
      state.captchaToken = payload
    },
    CAPTCHA_E_KEY(state, payload) {
      state.captchaEKey = payload
    },

    HAS_SIMPLE_SIGN_UP(state, payload) {
      state.hasSimpleSignUp = payload
    },

    USERNAME(state, payload) {
      state.username = payload
    },
    PASSWORD(state, payload) {
      state.password = payload
    },

    REG_USERNAME(state, payload) {
      state.regUsername = payload
    },
    REG_TEL(state, payload) {
      state.regTel = payload
    },
    REG_PASSWORD(state, payload) {
      state.regPassword = payload
    },
    REG_EMAIL(state, payload) {
      state.regEmail = payload
    },
    REG_EMAIL_VERIFY_CODE(state, payload) {
      state.regEmailVerifyCode = payload
    },
    REG_CONFIRM_PASSWORD(state, payload) {
      state.regConfirmPassword = payload
    },
    REG_WITHDRAWAL_PASSWORD(state, payload) {
      state.regWithdrawalPassword = payload
    },
    REG_ACTUAL_NAME(state, payload) {
      state.regActualName = payload
    },
    REG_ZALO(state, payload) {
      state.regZalo = payload
    },
    REG_BIRTHDAY(state, payload) {
      state.regBirthday = payload
    },
    REG_RECOMMENDED_CODE(state, payload) {
      state.regRecommendedCode = payload
    },
    REG_COUNTRY_CODE(state, payload) {
      state.regCountryCode = payload
    },
    REG_CURRENCY(state, payload) {
      state.regCurrency = payload
    },
    REG_GENDER(state, payload) {
      state.regGender = payload
    },

    LOGIN_MODAL(state, payload) {
      state.loginModal = { ...payload }
    },

    RECOVERY_MODAL(state, payload) {
      state.recoveryModal = { ...payload }
    },
    SHOW_SELECT_SIGN_UP_TYPE_MODAL(state, payload) {
      state.showSelectSignUpTypeModal = payload
    },

    FP_CATEGORY(state, payload) {
      state.fpCategory = payload
    },
    FP_USERNAME(state, payload) {
      state.fpUsername = payload
    },
    FP_TEL(state, payload) {
      state.fpTel = payload
    },
    FP_COUNTRY_CODE(state, payload) {
      state.fpCountryCode = payload
    },
    FP_EMAIL(state, payload) {
      state.fpEmail = payload
    },

    ORIGIN_PASSWORD(state, payload) {
      state.originPassword = payload
    },
    NEW_PASSWORD(state, payload) {
      state.newPassword = payload
    },
    CONFIRM_PASSWORD(state, payload) {
      state.confirmPassword = payload
    },

    IS_PAY_PASSWORD_SETTING(state, payload) {
      state.isPayPasswordSetting = payload
    },
    ORIGIN_PAY_PASSWORD(state, payload) {
      state.originPayPassword = payload
    },
    NEW_PAY_PASSWORD(state, payload) {
      state.newPayPassword = payload
    },
    CONFIRM_PAY_PASSWORD(state, payload) {
      state.confirmPayPassword = payload
    },
    LOGIN_PASSWORD(state, payload) {
      state.loginPassword = payload
    },
    EMAIL_VERIFY_CODE(state, payload) {
      state.emailVerifyCode = payload
    }
  },
  getters: {
    token: state => state.token,
    encryptToken: state => state.encryptToken,
    tokenExp: state => state.tokenExp,
    user: state => state.user,

    imageSrc: state => state.imageSrc,
    imageCode: state => state.imageCode,
    imageToken: state => state.imageToken,

    hasSimpleSignUp: state => state.hasSimpleSignUp,

    username: state => state.username,
    password: state => state.password,

    regUsername: state => state.regUsername,
    regTel: state => state.regTel,
    regPassword: state => state.regPassword,
    regRecommendedCode: state => state.regRecommendedCode,
    regEmail: state => state.regEmail,
    regEmailVerifyCode: state => state.regEmailVerifyCode,
    regConfirmPassword: state => state.regConfirmPassword,
    regWithdrawalPassword: state => state.regWithdrawalPassword,
    regActualName: state => state.regActualName,
    regZalo: state => state.regZalo,
    regBirthday: state => state.regBirthday,
    regCountryCode: state => state.regCountryCode,
    regCurrency: state => state.regCurrency,
    regGender: state => state.regGender,

    loginModal: state => state.loginModal,
    recoveryModal: state => state.recoveryModal,
    showSelectSignUpTypeModal: state => state.showSelectSignUpTypeModal,

    fpCategory: state => state.fpCategory,
    fpUsername: state => state.fpUsername,
    fpTel: state => state.fpTel,
    fpCountryCode: state => state.fpCountryCode,
    fpEmail: state => state.fpEmail,

    originPassword: state => state.originPassword,
    newPassword: state => state.newPassword,
    confirmPassword: state => state.confirmPassword,

    isPayPasswordSetting: state => state.isPayPasswordSetting,
    originPayPassword: state => state.originPayPassword,
    newPayPassword: state => state.newPayPassword,
    confirmPayPassword: state => state.confirmPayPassword,
    loginPassword: state => state.loginPassword,
    emailVerifyCode: state => state.emailVerifyCode
  }
}
